module.exports = __webpack_public_path__ + "img/Medication Safety in Pregnancy and Lactation.5718c77c.jpg";